import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import ReportTable from "../components/Reports/MonthlyReportTable";

const MonthlyReport = () => {
  return (
    <Container>
      <PageHeader
        pageTitle="Aylık Rapor"
        subText="Seçilen ay aralığındaki toplam çalışma saati ve devam özeti."
      />
      <ReportTable />
    </Container>
  );
};

export default MonthlyReport;
